import { render } from "./Overlay.vue?vue&type=template&id=76b2de9e&scoped=true"
import script from "./Overlay.vue?vue&type=script&lang=js"
export * from "./Overlay.vue?vue&type=script&lang=js"

import "./Overlay.vue?vue&type=style&index=0&id=76b2de9e&lang=scss&scoped=true"

import exportComponent from "/root/Fnedu/build/build20250805.141732/dashboard/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76b2de9e"]])

export default __exports__